import { render, staticRenderFns } from "./StaffSetBranch.vue?vue&type=template&id=6d4260e9&"
import script from "./StaffSetBranch.vue?vue&type=script&lang=js&"
export * from "./StaffSetBranch.vue?vue&type=script&lang=js&"
import style0 from "./StaffSetBranch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports